module.exports = __webpack_public_path__ + "img/com.8c48c334.jpg";